import styled from "styled-components";

export const LoginPopupBox = styled.div`
  @media ${({theme}) => theme.mediaQuery.lAndAbove } {
      min-width: 400px;
  }
  
  min-width: 300px;

`;